// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";


// Stateless components

export function ContextualMessage(props) {

    var key = props['id'];

    //
    // Render
    //
        
    function renderMessage(context) {

        var staff_mode = context['staff_mode'];
        var icons = context['configuration']['icons'];
        var info_icon = {
            '__html': icons['info']
        };

        var configuration = context['configuration'];
        var contextual_messages = configuration['contextual_messages'];

        var message = key ? contextual_messages[key] : null;

        if (staff_mode && message) {
            return (
                <div className="contextual-panel__wrapper">
                    <div className="contextual-panel__info--icon" dangerouslySetInnerHTML={info_icon}></div>
                    <div className="contextual-panel__content">
                        {message}
                    </div>
                </div>
            );
        }

        return null;
    }

    return (
        <PortalContext.Consumer>
            {renderMessage}
        </PortalContext.Consumer>
    );
};
